import React from "react";
import DeviceLocationMap from "./DeviceLocationMap";
import Footer from "../../components/common/Footer";

const VehicleTracker = ({ vehicleId, isSchoolMonitor = false }) => {
  return (
    <>
      <DeviceLocationMap
        vehicleId={vehicleId}
        isSchoolMonitor={isSchoolMonitor}
      />
      <Footer />
    </>
  );
};

export default VehicleTracker;